import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider, LinearProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";
import "../grid/layout/DataGridMomSysOrderPurchase.css"
import DialogHeader from "../dialog/functional/DialogHeader";

function TkInsertStandardUnitPriceExcelUploadDialog ( props ) {

    const {

        id,
        schema,
        formId,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,
        
        title,

        ...others

    } = props;

    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();
    const [disabled, setDisabled] = useState ( true );
    const [cancelDisabled, setCancelDisabled] = useState(false);
    const [formData, setFormData] = useState({});
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [isExcelUploading, setIsExcelUploading] = useState(false);


    if ( schema && ! schema.columnMap ) {

        let columnMap = {};

        for ( const column of schema.columns ) {

            columnMap[column.name] = column;

        }

        schema.columnMap = columnMap;

    }

    const checkItemValidataion = ( schema, formData ) => {
    for ( const column of schema.columns ) {
        let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

        if ( !valid ) {

            nofifyWarning ( msg );
            return false;

        }
        
    }

        return true;

    }

    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        if (onSuccess) {

            setTimeout(() => onSuccess(result.data), 0);
        }

        instance.hide();

        setIsExcelUploading(false);

    };

    const onApiFailure = (reason) => {

        notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

        setIsExcelUploading(false);
        setDisabled(false);
        setCancelDisabled(false);
        
    };

    const onOk = ( schema, formData ) => {

        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        setIsExcelUploading(true);
        setDisabled(true);
        setCancelDisabled(true);

        // build base api url

        let url ;

        url = "/api/TkInsertStandardUnitPrice?excel";

        let apiData = { ...formData };

        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file" ) {

                deleted[formItem] = apiData[formItem].deletedFiles;

                for ( const file of apiData[formItem].activeFiles ) {

                    if ( file.type === "url" ) continue;

                    form.append ( formItem, file.file );

                }

            } else {

                if ( apiData[formItem] !== undefined ) {

                    json[formItem] = apiData[formItem];

                }

            }
        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );

        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        setFormData( null );

        instance.hide();

    };

    const onChange = ( formData ) => {

        setFormData(formData);

        setDisabled ( false );

    }
    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        setFormData( null );
        
        if ( onClose && !isExcelUploading ) {

            setDisabled(false);
            onClose ();

        }

    }

    const setInitialDataCallback = ( formData ) => {

        if ( !formData ) {
    
            formData = {};
            
        }
        formData.standardNum = " ";
        formData.costCode = " ";
      }

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth={maxWidth ? maxWidth : uiConf.autoFormDialogMaxWidth}
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeader>
                <DialogTitle>
                    { t ( "dialog.title.TkInsertStandardUnitPrice.excelUpload" ) }
                </DialogTitle>
            </DialogHeader>

            <Divider />

            <DialogContent dividers>

                <AutoForm
                    id={formId}
                    schema={schema}
                    mode="create"
                    onChange={onChange}
                    setInitialDataCallback={setInitialDataCallback}
                />

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            {
                isExcelUploading ?

                <LinearProgress color="primary" />
                :
                <></>

            }
            <DialogActionsOkCancel
                labels={[ t("common.ok")]}
                buttonDisabled={[disabled, cancelDisabled]}
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default TkInsertStandardUnitPriceExcelUploadDialog;
